import { NgClass } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TrackAttachmentParams, TrackLoginRequestParams } from '@app/models/tracking/track-event-param-type';
import { ButtonComponent } from '@commonComponents/button/button.component';
import { LoadingComponent } from '@commonComponents/loading/loading.component';
import { delayHelper } from '@commonHelpers/delay-helper';
import { isNullish } from '@commonHelpers/math-utils';
import { TranslatePipe } from '@commonNodeModules/@ngx-translate/core';
import { ConfirmDialogService } from '@commonServices/confirm-dialog.service';
import { CatalogDetailsType } from '@enums/catalog-details-type';
import { ViewType } from '@enums/view-type';
import { LoginSource } from '@interfaces/HttpClient/AnalyticsApiTrackingModels';
import { ViewGroupItemDto } from '@interfaces/HttpClient/CatalogApiPublicModels';
import { AccountService } from '@services/account.service';
import { AnalyticsTrackingFacadeService } from '@services/analytics-tracking-facade.service';
import { UserAuthorizationService } from '@services/user-authorization.service';
import { ViewTypeService } from '@services/view-type.service';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-showinviewer',
	templateUrl: './showinviewer.component.html',
	styleUrls: ['./showinviewer.component.scss'],
	imports: [NgClass, ButtonComponent, LoadingComponent, TranslatePipe]
})
export class ShowinviewerComponent implements OnInit, OnDestroy {

	@Input() attachment: ViewGroupItemDto;
	@Input() isLoading: boolean;
	@Input() showLoading = false;
	@Input() showButton = true;
	@Input() catalogKey: string;
	@Output() showViewer = new EventEmitter();
	@Input() catalogDetailsType: CatalogDetailsType;
	public viewType = ViewType;
	private currentViewType$ = this.viewTypeService.currentViewType$
	private subscription: Subscription
	public currentViewType: ViewType


	constructor(
		private confirmDialogService: ConfirmDialogService,
		private userAuthorizationService: UserAuthorizationService,
		private trackingFacadeService: AnalyticsTrackingFacadeService,
		private route: ActivatedRoute,
		private viewTypeService: ViewTypeService,
		private cdRef: ChangeDetectorRef,
		private accountService: AccountService
	) { }

	ngOnInit(): void {
		this.subscription = this.currentViewType$.subscribe(currentViewType => {
			this.currentViewType = currentViewType
			this.cdRef.detectChanges();

		})
	}

	ngOnDestroy(): void {
		this.subscription?.unsubscribe()
	}

	public async showViewerClick() {
		if (!this.accountService.isLoggedIn()) {
			await this.requestLoginDialog();
		} else {
			this.showViewer.emit();
			if (this.catalogDetailsType !== CatalogDetailsType.Preview) {
				this.trackingFacadeService.handleTrackEvent(new TrackAttachmentParams(
					this.catalogKey,
					this.route.snapshot.params.catalogItemGuid,
					isNullish(this.attachment.id) ? null : this.attachment.id,
					false,
					true
				))
			}
		}
	}

	private async requestLoginDialog() {
		// open confirm dialog
		this.confirmDialogService.open({
			title: 'catalog-view.thirdpartyviewer.request-login.title',
			confirm: 'global.login-registration',
			description: 'catalog-view.thirdpartyviewer.request-login.description',
			reject: 'catalog-view.thirdpartyviewer.request-login.reject'
		}, async () => { await this.login() });
	}

	private async login() {
		this.cdRef.detectChanges();
		delayHelper(async () => {
			this.userAuthorizationService.clearData();
			this.trackingFacadeService.handleTrackEvent(new TrackLoginRequestParams(LoginSource.Viewer, this.catalogKey, this.route.snapshot.params.catalogItemGuid, isNullish(this.attachment.id) ? null : this.attachment.id))
			await this.trackingFacadeService.commitAllTrackEvents();
			await this.accountService.login();
		})

	}

}
